import React from "react";

const LengthenRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.19941 2.94995C1.89566 2.94995 1.64941 3.19619 1.64941 3.49995C1.64941 3.80371 1.89566 4.04995 2.19941 4.04995H13.7994C14.1032 4.04995 14.3494 3.80371 14.3494 3.49995C14.3494 3.19619 14.1032 2.94995 13.7994 2.94995H2.19941ZM2.19941 11.95C1.89566 11.95 1.64941 12.1962 1.64941 12.5C1.64941 12.8037 1.89566 13.05 2.19941 13.05H7.79941C8.10317 13.05 8.34941 12.8037 8.34941 12.5C8.34941 12.1962 8.10317 11.95 7.79941 11.95H2.19941ZM1.64941 6.49995C1.64941 6.19619 1.89566 5.94995 2.19941 5.94995H13.7994C14.1032 5.94995 14.3494 6.19619 14.3494 6.49995C14.3494 6.80371 14.1032 7.04995 13.7994 7.04995H2.19941C1.89566 7.04995 1.64941 6.80371 1.64941 6.49995ZM2.19941 8.94995C1.89566 8.94995 1.64941 9.19619 1.64941 9.49995C1.64941 9.80371 1.89566 10.05 2.19941 10.05H13.7994C14.1032 10.05 14.3494 9.80371 14.3494 9.49995C14.3494 9.19619 14.1032 8.94995 13.7994 8.94995H2.19941Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(LengthenRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;